/**
 * waTemplates — 4 named recovery templates with dynamic variable substitution.
 * Variables: {name}, {amount}, {date}, {product}, {shop}, {days_late}
 */
export const WA_TEMPLATES = [
  {
    key: "payment_reminder",
    label: "Payment Reminder",
    icon: "💰",
    body:
      "Assalam o Alaikum {name},\n\n" +
      "Aap ki installment due hai:\n" +
      "• Product: {product}\n" +
      "• Amount: PKR {amount}\n" +
      "• Due Date: {date}\n\n" +
      "Bara meherbani timely payment kar dein.\n— {shop}",
  },
  {
    key: "friendly",
    label: "Friendly Reminder",
    icon: "🙂",
    body:
      "Assalam o Alaikum {name},\n\n" +
      "Yeh ek dosti se reminder hai — aap ki PKR {amount} ki installment {date} ko due thi. " +
      "Aap se request hai jaldi clear kar dein, koi pareshani ho to humein bata dein.\n\n— {shop}",
  },
  {
    key: "final_warning",
    label: "Final Warning",
    icon: "⚠️",
    body:
      "Mohtaram {name},\n\n" +
      "Yeh AAKHRI REMINDER hai. Aap ki installment {amount} PKR ({date} due) ab tak clear nahi hui — " +
      "{days_late} din late ho chuki hai. Agar 24 ghante mein payment nahi hui, hum legal aur recovery " +
      "process shuru karne par majboor hain.\n\n— {shop}",
  },
  {
    key: "guarantor",
    label: "Guarantor Reminder",
    icon: "🤝",
    body:
      "Assalam o Alaikum,\n\n" +
      "Aap {name} ke installment ke guarantor hain. Unki PKR {amount} ki installment ({date} due) " +
      "ab tak clear nahi hui. Bara meherbani unse rabta kar ke payment ka intezam karwa dein.\n\n— {shop}",
  },
];

export function renderTemplate(body, vars) {
  return body
    .replace(/\{name\}/g, vars.name || "")
    .replace(/\{amount\}/g, Number(vars.amount || 0).toLocaleString())
    .replace(/\{date\}/g, vars.date || "")
    .replace(/\{product\}/g, vars.product || "")
    .replace(/\{shop\}/g, vars.shop || "HisaabPro")
    .replace(/\{days_late\}/g, String(vars.days_late || 0));
}

/** Build a wa.me deep link from a PK-style mobile and a rendered template body. */
export function waLink(mobile, message) {
  if (!mobile) return null;
  const digits = (mobile || "").replace(/\D/g, "").replace(/^0/, "92");
  return `https://wa.me/${digits}?text=${encodeURIComponent(message)}`;
}
